/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Members_By_MonthInputs */

const en_admin_dashboard_members_by_month = /** @type {(inputs: Admin_Dashboard_Members_By_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members by month`)
};

const de_admin_dashboard_members_by_month = /** @type {(inputs: Admin_Dashboard_Members_By_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder pro Monat`)
};

const es_admin_dashboard_members_by_month = /** @type {(inputs: Admin_Dashboard_Members_By_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miembros por mes`)
};

const fr_admin_dashboard_members_by_month = /** @type {(inputs: Admin_Dashboard_Members_By_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membres par mois`)
};

const it_admin_dashboard_members_by_month = /** @type {(inputs: Admin_Dashboard_Members_By_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membri per mese`)
};

const pt_br2_admin_dashboard_members_by_month = /** @type {(inputs: Admin_Dashboard_Members_By_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membros por mês`)
};

const pl_admin_dashboard_members_by_month = /** @type {(inputs: Admin_Dashboard_Members_By_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Członkowie według miesiąca`)
};

const hu_admin_dashboard_members_by_month = /** @type {(inputs: Admin_Dashboard_Members_By_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagok havi bontásban`)
};

const ro_admin_dashboard_members_by_month = /** @type {(inputs: Admin_Dashboard_Members_By_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membri pe luna`)
};

/**
* | output |
* | --- |
* | "Members by month" |
*
* @param {Admin_Dashboard_Members_By_MonthInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_members_by_month = /** @type {((inputs?: Admin_Dashboard_Members_By_MonthInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Members_By_MonthInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_members_by_month(inputs)
	if (locale === "de") return de_admin_dashboard_members_by_month(inputs)
	if (locale === "es") return es_admin_dashboard_members_by_month(inputs)
	if (locale === "fr") return fr_admin_dashboard_members_by_month(inputs)
	if (locale === "it") return it_admin_dashboard_members_by_month(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_members_by_month(inputs)
	if (locale === "pl") return pl_admin_dashboard_members_by_month(inputs)
	if (locale === "hu") return hu_admin_dashboard_members_by_month(inputs)
	return ro_admin_dashboard_members_by_month(inputs)
});
export { admin_dashboard_members_by_month as "admin.dashboard.members_by_month" }